import { Backdrop, CircularProgress, Box, Button, CardMedia, Dialog, DialogActions, DialogContent, Grid, Hidden, IconButton, Menu, MenuItem, SelectChangeEvent, Skeleton, Switch, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Theme, Tooltip, Typography, useTheme } from "@mui/material";
import { useHistory, } from "react-router";
import { AIFActiveIcon, BlueEditIcon, WhiteDropDownIcon, BondsActiveIcon, CashAvailablePortfolioIcon, RupeeIcon, DownwardNegativeIcon, DropDownIcons, EmailIcon, HideIcon, InfoIconOutlined, InvestedValueIcon, JointHolderIcon, JointHoldersDisplayIcon, MutualFundsActiveIcon, PMSActiveIcon, Phoneicon, SIPReminderIcon, SuccessTickIcon, TransactionFailedIcon, UpWardPositiveIcon, ViewIcon, ViewProfileIcon, WeightedAvgDaysIcon, ZeroStateArrow, InProgressIcon, FailureIcon } from "../../assets/SvgIcons";
import { calculateOthersInPieChart, findRiskTolerance, isRMLikeRole, formatCurrency, getAbbreviatedName, getBgColorFromRisk, isOnboardingTypeMinor, maskInfo, toINR } from "../../utils/utilityFunctions";
import { ProductDirectEquityIcon } from "../customSVGs";
import CustomGaugeChart from "../dashboard/chart/CustomGaugeChart";

import { Order, SortingObj, TableBodyData, TableHeaderData } from "./types";
import CustomTable from "./common/customTable";
import RecentRecommendationsTableBody, { MobileResponsiveRecentRecommendations } from "./common/customTable/RecentRecommendationsTableBody";
import BreadCrum from "../../lib/BreadCrum";
import {
    getInvestorAllocation,
    getInvestorInfo,
    getLatestNotifications,
    getLatestRecommendations,
    setAppliedHoldingsFilters,
    setHoldingsActiveCategory,
    setSelectedHoldingsIds,
    setAppliedRecommendationsFilters, setRecommendationsActiveCategories,
    setCheckedHoldingSchemes,
    setSelectedHoldingsInfo,
    setSelectedAllHoldingsInfo,
    setAppliedFundsFilters,
    setSelectedSchemesObj,
    setExploreMutualFundsPageVisited,
    setSystematicPlansSearchText,
    setAppliedSystematicPlansFilters,
    getExpiringMandate,
    getPortfolioXirr
} from "../../redux-store/actions/investorProfile";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux-store/reducers";
import React, { useEffect, useState } from "react";
import { APPLICATION_TYPE, BONDS_LINK, ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, HELDAWAY_PORTFOLIO_STATUS, MPOWER_ACCOUNT_TYPE_MASTER, NO_DATA_AVAILABLE, NO_RECOMMENDATIONS, USER_ROLES } from "../../utils/constant";
import { ExpiringMandateRes, GetPortfolioXirrResponseBody, InvestorAllocationRes, InvestorInfoRes, LatestNotificationsRes, LatestRecommendationDataRes, NotificationObj } from "../../redux-store/types/investorProfile";
import dayjs from "dayjs";
import CustomePieChart from "../dashboard/chart/CustomePieChart";
import { ErrorText } from "../dashboard/chart/CustomeLineChart";
import { BottomMenu } from "./common/BottomMenu";
import { setLoggedInPortfolioHeldawayStatus, setPortfolioHeldawayStatus, storeLoggedInPortfolioList, storeLoggedInSelectedPortfolio, storeLoggedInSelectedPortfolioObj, storePortfolioList, storeSelectedPortfolio, storeSelectedPortfolioObj } from "../../redux-store/actions/portfolioFilter";
import { GetCartItemsCountResponseBody } from "../../redux-store/types/cart";
import { getCartItemsCount, setCartItemsCount } from "../../redux-store/actions/cart";
import { AssetClassDetailsRes, BenchmarkPerformanceRes } from "../../redux-store/types/products";
import { getAssetClassDetails, getBenchmarkPerformance } from "../../redux-store/actions/product";
import { PortfolioHealthChart } from "./PortfolioHealthChart";
import CustomDropdown from "./directEquity/directEquityOverview/CustomDropdown";
import { DropdownOption } from "./directEquity/types";
import { ZeroStateInvestment } from "./common/ZeroStateInvestment";
import { storeInterfaceCode, storeInvestorClientId, storeIsPortfolioAvailable, storeIwappId, setApplicantDetails, setFamilyDetails, storeShowMfcReport, storeInvApplicantId, storeApplicationType, storeBseClientActivationStatus, storeAssetClassActivationStatus } from "../../redux-store/actions/id";
import RiskScoreModal from "./RiskScoreModal";
import { setInvestorRmId } from "../../redux-store/actions/sessionData";
import { showError } from "../../redux-store/actions/auth";
import { GetInvestorInfoBody } from "../../redux-store/types/api-types";
import { useRoleStack } from "../../hooks/useRoleStack";
const assetClassIconMap: Record<number, JSX.Element> = {
    0: <MutualFundsActiveIcon />,
    1: <ProductDirectEquityIcon />,
    2: <PMSActiveIcon />,
    3: <BondsActiveIcon />,
    4: <AIFActiveIcon />
}

interface dashBoardNavigation {
    clientCode?: string | undefined
    portfoiloId?: string | undefined
    accountFilter?: number
}

const bseStarStatusColorMap: Record<string, string> = {
    pending: 'warning.500',
    active: 'success.500',
    failed: 'error.500'
}

const transactDropdownItems: Array<{ title: string; path: string; }> = [
    {
        title: "Invest",
        path: '/explore'
    },
    {
        title: "Additional Purchase",
        path: '?tab=Holdings'
    },
    {
        title: "Redeem",
        path: '?tab=Holdings'
    },
    {
        title: "Switch",
        path: '?tab=Holdings'
    },
    {
        title: "STP",
        path: '?tab=Holdings'
    },
    {
        title: "SWP",
        path: '?tab=Holdings'
    }
]

export default function InvestorProfile(): JSX.Element {
    const { selectedPortfolio, isExpiringMandate = false } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const { businessDate = "" } = useSelector((store: RootStateType) => store.navbarInfo);
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const history = useHistory();
    const { pathname: pathName, state } = history.location;

    // console.log('history.location', history.location);
    const dispatch = useDispatch()
    const { palette } = useTheme()
    const { id: userId, role = '' } = useSelector((state: RootStateType) => state.auth);
    const { investorClientId, iwappRmId, clientInterfaceCode, applicationId, isPortfolioAvailable = false, familyMemberId = "", viewAsFamilyId = "" } = useSelector((state: RootStateType) => state.id)
    const { investorRmId = "" } = useSelector((state: RootStateType) => state.sessionData)
    const navState = state as dashBoardNavigation
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [tableHeaderMenu, setTableHeaderMenu] = useState<boolean>(false)
    const [tableHeaderKey, setTableHeaderKey] = useState<string>('status')
    const [transactDropdownEl, setTransactDropdownEl] = useState<null | HTMLElement>(null);

    const [recentRecommendationsData, setRecentRecommendationsData] = useState<TableBodyData[]>([])
    const [sortingObj, setSortingObj] = useState<SortingObj>({ order: "desc", orderBy: "recommendedDate" })
    const [notifications, setNotifications] = useState<Array<NotificationObj>>([]);
    const [investorInfo, setInvestorInfo] = useState<InvestorInfoRes>({
        name: '',
        emailId: '',
        mobileNumber: '',
        investorType: '',
        riskScore: 0,
        rm: '',
        investedValue: 0,
        marketValue: 0,
        "gain/loss": 0,
        weightedAvgDays: 0,
        profile: '',
        irr: 0,
        cashAvailable: 0,
        rmIwappId: '',
        portfolio: {
            isPortfolioHeldaway: false,
            portfolioId: '',
            portfolioName: '',
            portfolioAccountType: ''
        },
        portfolioList: [],
        applicantNames: [],
        clientInterfaceCode: null,
        cashflow: 0,
        acceptedByMpower: null,
        bseClientActivationStatus: null,
        return: 0,
        neft_details: [],
        totalInvestedValue: 0,
        externalPortfolioDate: '',
        clientInvestedValue: 0,
        externalInvestedValue: 0
    })
    const theme = useTheme();

    const [assetLoading, setAssetLoading] = useState<boolean>(false);
    const [assetAllocation, setAssetAllocation] = useState<any>([]);
    const [isAssetAllocationError, setIsAssetAllocationError] = useState<boolean>(false);
    const [isPortfolioAllocationError, setIsPortfolioAllocationError] = useState<boolean>(false);
    const [portfolioLoading, setPortfolioLoading] = useState<boolean>(false);
    const [portfolioAllocation, setPortfolioAllocation] = useState<any>([]);
    const [assetClassObj, setAssetClassObj] = useState({} as AssetClassDetailsRes);
    const [benchmarkPerformanceLoader, setBenchMarkPerformanceLoader] = useState<boolean>(false);
    const [investorPortfolioOptions, setInvestorPortfolioOptions] = useState<Array<DropdownOption>>([])
    const [portfolioChangeFilter, setPortfolioChangeFilter] = useState<string | number>('');
    const [recommendationsLoading, setRecommendationsLoading] = useState<boolean>(false);
    const [investorInfoLoading, setInvestorInfoLoading] = useState<boolean>(false);
    const [riskScoreLoading, setRiskScoreLoading] = useState<boolean>(false);
    const [performanceData, setPerformanceData] = useState<BenchmarkPerformanceRes>({} as BenchmarkPerformanceRes);
    const [notificationsLoader, setNotificationsLoader] = useState<boolean>(false);
    const [portfolioDropdownOptions, setPortfolioDropdownOptions] = useState<string>('1');
    const [assetDropdownOptions, setAssetDropdownOptions] = useState<string>('1');
    const [zeroStateCheck, setZeroStateCheck] = useState<boolean>(false);
    const [investedValueCheck, setInvestedValueCheck] = useState<boolean>(false);
    const [assetClassLoader, setAssetClassLoader] = useState<boolean>(false);
    const [openRiskScore, setOpenRiskScore] = useState<boolean>(false);
    const [isMfcReportVisible, setMfcReportVisible] = useState<boolean>(false)
    const [maskedData, setMaskedData] = useState<boolean>(false)
    const [expiringMandateDialog, setExpiringMandateDialog] = useState<boolean>(false)
    const [pendingMandateData, setPendingMandateData] = useState<any>({})
    const [isToggleIrr, setToggleIrr] = useState<boolean>(false)
    const [toggleValue, setToggleValue] = useState<number>(0)
    const [isToggleLoading, setToggleLoading] = useState<boolean>(false)

    const formattedBusinessDate = businessDate ? dayjs(businessDate, 'DD/MM/YYYY').format('DD MMM, YYYY') : "-"
    const isFamilyView = pathName.includes('investor-family') && clientInterfaceCode !== viewAsFamilyId

    const recommendationsTableData = async (order = "DESC", sort = "recommendedDate", value = '') => {
        // Handling Recommendations Api Call here
        try {
            setRecommendationsLoading(true);
            const recommendationsPayload = {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : isFamilyView ? viewAsFamilyId : investorClientId,
                order: order?.toUpperCase(),
                portfolioId: value ? value : isFamilyView ? ' ' : navState?.portfoiloId,
                sort,
            }

            const recentRecommendationRes = await (dispatch(getLatestRecommendations(recommendationsPayload)) as unknown as Promise<LatestRecommendationDataRes>)


            const modifiedRecommendationsForTable = recentRecommendationRes?.FinalData?.map((recommendation) => ({
                ...recommendation,
                id: recommendation?.id,
                schemeName: recommendation?.schemeName,
                status: recommendation?.status ?? "-",
                transactionType: recommendation?.buySellType,
                amount: toINR({ value: recommendation?.recommendedAmount, locale, currencyCode }),
                date: recommendation?.recommendedDate ? dayjs(recommendation?.recommendedDate, "DD/MM/YYYY").format("DD MMM, YY") : '-'
            }))


            setRecentRecommendationsData(modifiedRecommendationsForTable)
        } catch (e) {
            console.log("ERROR IN FETCHING RECOMMENDATIONS", e);
        } finally {
            setRecommendationsLoading(false);
        }


    }

    const getNotifications = async (value = '', pan = "") => {
        try {
            setNotificationsLoader(true);
            const notificationsRes = await (dispatch(getLatestNotifications({
                clientCode: isRMLikeRole(role) ? navState?.clientCode : isFamilyView ? viewAsFamilyId : investorClientId,
                portfolioId: value ? value : (viewAsFamilyId ? "" : (selectedPortfolio?.value || navState?.portfoiloId || "")),
                limit: 5,
                pan,
                currentPage: 1
            })) as unknown as Promise<LatestNotificationsRes>)

            setNotifications(notificationsRes?.notifications ?? [])
        } catch (e) {
            console.log('error', e);
        } finally {
            setNotificationsLoader(false);
        }

    }

    const fetchAssetAllocation = async (portfolioValue = '', categoryValue = 1, currentRmId = "") => {
        try {
            setAssetLoading(true);
            setAssetAllocation([])
            const assetAllocationRes: any = (await dispatch(getInvestorAllocation({
                clientCode: isRMLikeRole(role) ? navState?.clientCode : isFamilyView ? viewAsFamilyId : investorClientId,
                category: categoryValue === 1 ? 'Asset Group' : 'Asset Class',
                rmId: `${currentRmId ?? ''}`,
                portfolio: portfolioValue
            }))) as unknown as Promise<InvestorAllocationRes>;
            if (assetAllocationRes?.isSuccess) {
                setIsAssetAllocationError(false)
                setAssetAllocation({ ...assetAllocationRes, result: { ...assetAllocationRes?.result } })
            } else {
                setIsAssetAllocationError(true)
            }

        } catch (e) {
            setAssetAllocation([])
            setIsAssetAllocationError(true)
            console.log("ERROR", e);
        } finally {
            setAssetLoading(false)
        }
    }

    const fetchPortfolioAllocation = async (portfolioValue = '', categoryValue = 1, currentRmId = "") => {
        try {
            setPortfolioLoading(true);
            setPortfolioAllocation([])
            const portfolioAllocationRes: any = (await dispatch(getInvestorAllocation({
                clientCode: isRMLikeRole(role) ? navState?.clientCode : isFamilyView ? viewAsFamilyId : investorClientId,
                category: categoryValue === 1 ? 'Sector' : 'Issuer',
                rmId: `${currentRmId ?? ''}`,
                portfolio: portfolioValue
            }))) as unknown as Promise<InvestorAllocationRes>;

            if (portfolioAllocationRes?.isSuccess) {
                setIsPortfolioAllocationError(false);
                setPortfolioAllocation({ ...portfolioAllocationRes, result: { ...portfolioAllocationRes?.result } })

            } else {
                setIsPortfolioAllocationError(true);
            }
        } catch (e) {
            setPortfolioAllocation([])
            console.log("Error", e);
            setIsPortfolioAllocationError(true);
        } finally {
            setPortfolioLoading(false)
        }
    }

    const fetchBenchMarkPerformance = async (value: string | number = '', currentRmId = "") => {
        try {
            setBenchMarkPerformanceLoader(true);
            const investor360PerformanceRes = await (dispatch(getBenchmarkPerformance({
                clientCode: isRMLikeRole(role) ? navState?.clientCode : isFamilyView ? viewAsFamilyId : investorClientId,
                portfolioId: value ? `${value}` : selectedPortfolio?.value,
                rmId: `${currentRmId ?? ''}`,
            })) as unknown as Promise<BenchmarkPerformanceRes>)
            setPerformanceData(investor360PerformanceRes);
        } catch (e) {
            console.log('error', e);
        } finally {
            setBenchMarkPerformanceLoader(false);
        }
    }

    const fetchAssetClassDetails = async (value: string | number = '', currentRmId = "") => {
        try {
            setAssetClassLoader(true);
            const assetClassRes = await (dispatch(getAssetClassDetails({
                clientCode: isRMLikeRole(role) ? navState?.clientCode : isFamilyView ? viewAsFamilyId : investorClientId,
                portfolioId: value ? `${value}` : selectedPortfolio?.value,
                rmId: `${currentRmId ?? ''}`,
            })) as unknown as Promise<AssetClassDetailsRes>)
            if (!assetClassRes?.isSuccess) return;
            dispatch(storeAssetClassActivationStatus({
                mutual_funds: assetClassRes?.result?.mutual_funds?.is_holdings_available ?? false,
                debt: assetClassRes?.result?.debt?.is_holdings_available ?? false,
                pms: assetClassRes?.result?.pms?.is_holdings_available ?? false,
                alternates: assetClassRes?.result?.alternates?.is_holdings_available ?? false,
                direct_equity: assetClassRes?.result?.direct_equity?.is_holdings_available ?? false
            }))
            setAssetClassObj({ ...assetClassObj, result: { ...assetClassRes?.result, mutual_funds: assetClassRes?.result?.mutual_funds, bonds: assetClassRes?.result?.debt, pms: assetClassRes?.result?.pms, alternates: assetClassRes?.result?.alternates, direct_equity: assetClassRes?.result?.direct_equity } });
        } catch (e) {
            console.log('error', e);
        } finally {
            setAssetClassLoader(false);
        }
    }

    const fetchInvestorInfoApi = async ({
        clientCode,
        portfolio,
        applicationId,
        rmId
    }: GetInvestorInfoBody) => {
        return await (dispatch(getInvestorInfo({
            clientCode,
            portfolio,
            applicationId,
            rmId,
        })) as unknown as Promise<InvestorInfoRes>)
    }

    function getPayloadClientCode() {
        // clientCode: (isRMLikeRole(role) ? navState?.clientCode : isFamilyView ? viewAsFamilyId : investorClientId) ?? "",

        let payloadClientCode = ""

        if (isRMLikeRole(role)) {
            payloadClientCode = navState?.clientCode ?? ""
        } else if (isFamilyView) {
            payloadClientCode = viewAsFamilyId ?? ""
        } else {
            payloadClientCode = investorClientId ?? "";
        }

        return payloadClientCode
    }

    function getPayloadPortfolio(value: string | number) {

        let payloadPortfolio: string | number = ""

        if (value) {
            payloadPortfolio = value
        }
        else if (!isFamilyView) {
            payloadPortfolio = ""
        }
        else {
            payloadPortfolio = (selectedPortfolio?.value || navState?.portfoiloId || "")
        }

        return payloadPortfolio
    }

    function getPayloadApplicationId(value: string | number) {

        let result: string | number | undefined | null

        if (isFamilyView) {
            result = null
        }
        else {
            result = applicationId
        }

        return result
    }

    const callInvestorInfo = async (value: string | number = '') => {
        try {
            setInvestedValueCheck(false);
            setZeroStateCheck(false);
            setInvestorInfoLoading(true);
            if (value) {
                setRiskScoreLoading(false);
            } else {
                setRiskScoreLoading(true);
            }

            const investorInfoRes = await fetchInvestorInfoApi({
                clientCode: getPayloadClientCode(),
                portfolio: getPayloadPortfolio(value),
                applicationId: getPayloadApplicationId(value),
                rmId: `${iwappRmId}`,
            })
            if (!pathName.includes('investor-family')) {
                dispatch(storeIsPortfolioAvailable(investorInfoRes?.isSuccess ?? false))
            }
            dispatch(storeBseClientActivationStatus(investorInfoRes?.bseClientActivationStatus ?? ""))

            if (investorInfoRes.isSuccess) {
                const primaryApplicant = (investorInfoRes?.application?.applicants ?? []).find(obj => obj.applicant_type === "1") ?? {}

                dispatch(setApplicantDetails({
                    panNo: primaryApplicant?.panNo ?? "",
                    email: primaryApplicant?.email ?? "",
                    mobile: primaryApplicant?.mobile ?? "",
                    countryCode: primaryApplicant?.countryCode ?? ""
                }))

                // eCAS button to be shown only for Resident Individual Single Holding

                const isResidentIndividualSingleHolding = (
                    `${investorInfoRes?.application?.modeOfHolding ?? ""}`.toLowerCase() === "single" && //Single Holding
                    `${primaryApplicant?.status ?? ""}`.toLowerCase() === "individual" && //Resident
                    `${investorInfoRes?.application?.applicationType ?? ""}`.toLowerCase() === "individual" //Individual
                )

                setMfcReportVisible(isResidentIndividualSingleHolding)

                dispatch(storeShowMfcReport(isResidentIndividualSingleHolding))
                if (!pathName.includes('investor-family')) {
                    dispatch(setFamilyDetails({
                        familyId: investorInfoRes?.familyId ?? "",
                        familyName: investorInfoRes?.familyName ?? "",
                        isCustFamilyHead: investorInfoRes?.isCustFamilyHead ?? ""
                    }))
                }

                // dispatch(storeIwappId({ iwappRmId: investorInfoRes?.rmIwappId ?? '' }));
                dispatch(storeInvApplicantId({ applicantId: investorInfoRes?.application?.applicants?.[0]?.id ?? '' }));
                const firstApplicant = investorInfoRes?.application?.applicants?.[0];
                const isMinorOnboarding = `${firstApplicant?.onboardingType ?? ''}`.toLowerCase() === 'minor';
                dispatch(storeApplicationType({
                    applicationType: investorInfoRes?.application?.applicationType ?? '',
                    investorName: investorInfoRes?.name ?? '',
                    status: firstApplicant?.status ?? '',
                    onboardingType: (firstApplicant?.onboardingType ?? '') as unknown as string,
                    minorFirstName: isMinorOnboarding ? (firstApplicant?.minorFirstName ?? '') : '',
                    minorLastName: isMinorOnboarding ? (firstApplicant?.minorLastName ?? '') : '',
                }));
                dispatch(setInvestorRmId(investorInfoRes?.rmIwappId ?? ''))
                if (!pathName.includes('investor-family')) {
                    dispatch(storeInvestorClientId({ investorClientId: investorInfoRes?.clientCode ?? "" }))
                }
                const modifiedInvestorInfoRes = {
                    ...investorInfoRes,
                    name: maskInfo(investorInfoRes?.name),
                    emailId: maskInfo(investorInfoRes?.emailId),
                    mobileNumber: maskInfo(investorInfoRes?.mobileNumber),
                }
                if (modifiedInvestorInfoRes?.investedValue === 0) {
                    setInvestedValueCheck(true);
                }
                setInvestorInfo(modifiedInvestorInfoRes)
                setToggleValue(Number(modifiedInvestorInfoRes?.return ?? ""))
                const portfolioObj = modifiedInvestorInfoRes?.portfolioList?.map((portfolio) => {
                    return (
                        {
                            ...portfolio,
                            label: maskInfo(portfolio?.portfolioName),
                            value: portfolio?.portfolioId
                        }
                    )
                }) ?? [{
                    label: '',
                    value: ''
                }]
                setInvestorPortfolioOptions(portfolioObj)
                setPortfolioChangeFilter(modifiedInvestorInfoRes?.portfolio?.portfolioId)
                const resolvedSelectedPortfolio = modifiedInvestorInfoRes?.portfolio ? portfolioObj?.filter((item) => item.value === modifiedInvestorInfoRes?.portfolio?.portfolioId)[0] : {
                    label: '',
                    value: ''
                }
                const resolvedIsPortfolioHeldaway = modifiedInvestorInfoRes?.portfolio?.isPortfolioHeldaway ?? false
                dispatch(storeSelectedPortfolio(resolvedSelectedPortfolio))
                dispatch(storeSelectedPortfolioObj(modifiedInvestorInfoRes?.portfolio ?? {}))
                dispatch(storePortfolioList(portfolioObj))
                dispatch(setPortfolioHeldawayStatus(resolvedIsPortfolioHeldaway))
                // Snapshot the logged-in investor's portfolio context so that
                // the sidebar always has the right context, even after the
                // user navigates to another investor via the Family flow
                // (which overrides `selectedPortfolio`, `selectedPortfolioObj`,
                // `portfolioList`, and `isPortfolioHeldaway`). Only do this
                // when NOT inside the family flow, otherwise we would
                // overwrite the snapshot with the clicked investor's data.
                if (!pathName.includes('investor-family')) {
                    dispatch(storeLoggedInSelectedPortfolio(resolvedSelectedPortfolio))
                    dispatch(storeLoggedInSelectedPortfolioObj(modifiedInvestorInfoRes?.portfolio ?? {}))
                    dispatch(storeLoggedInPortfolioList(portfolioObj))
                    dispatch(setLoggedInPortfolioHeldawayStatus(resolvedIsPortfolioHeldaway))
                }
                if (!pathName.includes('investor-family')) {
                    dispatch(storeInterfaceCode(modifiedInvestorInfoRes.clientInterfaceCode))
                }


                const investorPortfolio = portfolioObj.filter((item) => item.value === modifiedInvestorInfoRes?.portfolio?.portfolioId)[0].value;

                if (role === USER_ROLES.INVESTOR) {
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : isFamilyView ? viewAsFamilyId : investorClientId,
                        portfolioId: portfolioObj.filter((item) => item.value === modifiedInvestorInfoRes?.portfolio?.portfolioId)[0].value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)

                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                    }
                    if (!isExpiringMandate) {
                        const pendingMandateRes = await (dispatch(getExpiringMandate({
                            clientCode: clientInterfaceCode ? clientInterfaceCode : isFamilyView ? viewAsFamilyId : investorClientId,
                            portfolioId: portfolioObj.filter((item) => item.value === modifiedInvestorInfoRes?.portfolio?.portfolioId)[0].value
                        })) as unknown as Promise<ExpiringMandateRes>)
                        if (!pendingMandateRes) {
                            return;
                        }
                        if (pendingMandateRes?.show_popup) {
                            setExpiringMandateDialog(true);
                            setPendingMandateData(pendingMandateRes);
                        }
                    }
                }

                await Promise.allSettled([recommendationsTableData('DESC', 'recommendedDate', value ? `${value}` : (isFamilyView ? "" : (investorPortfolio || navState?.portfoiloId))),
                getNotifications(value ? `${value}` : (isFamilyView ? "" : (investorPortfolio || navState?.portfoiloId)), primaryApplicant?.panNo ?? ""),
                fetchAssetAllocation((value ? `${value}` : (isFamilyView ? "" : (investorPortfolio || navState?.portfoiloId))), 1, `${investorInfoRes?.rmIwappId ?? ''}`),
                fetchPortfolioAllocation((value ? `${value}` : (isFamilyView ? "" : (investorPortfolio || navState?.portfoiloId))), 1, `${investorInfoRes?.rmIwappId ?? ''}`),
                fetchBenchMarkPerformance(value ? value : (isFamilyView ? "" : (investorPortfolio || navState?.portfoiloId)), `${investorInfoRes?.rmIwappId ?? ''}`)])
                fetchAssetClassDetails(value ? value : (isFamilyView ? "" : (investorPortfolio || navState?.portfoiloId)), `${investorInfoRes?.rmIwappId ?? ''}`)
            }
            else {
                setInvestorInfo(investorInfoRes);
                setZeroStateCheck(true);
                return;
            }
        } catch (e) {
            console.log("ERROR IN FETCHING INVESTOR INFO", e);
        } finally {
            setInvestorInfoLoading(false);
            setRiskScoreLoading(false);
        }

    }

    const handleMandateAuthenticationClick = (index: number) => {
        const isMandateUrl = `${notifications?.[index]?.url ?? ''}`?.startsWith('https://');
        if (isMandateUrl) {
            window.open(`${notifications?.[index]?.url}`, '_blank');
        }
    }

    useEffect(() => {
        dispatch(setSelectedHoldingsInfo([]))
        dispatch(setSelectedAllHoldingsInfo([]))
        const fetchInvestorInfo = async () => {
            await callInvestorInfo()
        }
        fetchInvestorInfo()
    }, [])


    const assestPercentages = [
        {

            "name": "Mutual Funds",
            "value": Math.round(assetClassObj?.result?.mutual_funds?.return ?? 0),
            "is_holdings_available": true
        },
        {
            "name": "Debt & Bonds",
            "value": Math.round(assetClassObj?.result?.debt?.return ?? 0),
            "is_holdings_available": assetClassObj?.result?.debt?.is_holdings_available
        },
        {
            "name": "PMS",
            "value": Math.round(assetClassObj?.result?.pms?.return ?? 0),
            "is_holdings_available": assetClassObj?.result?.pms?.is_holdings_available
        },
        {
            "name": "Alternates",
            "value": Math.round(assetClassObj?.result?.alternates?.return ?? 0),
            "is_holdings_available": assetClassObj?.result?.alternates?.is_holdings_available
        },
        {
            "name": "Direct Equity",
            "value": Math.round(assetClassObj?.result?.direct_equity?.return ?? 0),
            "is_holdings_available": assetClassObj?.result?.direct_equity?.is_holdings_available
        },
    ]



    const investorPortfolioCards = [
        {
            label: "Consolidated Invested Value",
            value: investorInfo?.totalInvestedValue ? (investorInfo?.totalInvestedValue < 0 ? `- ${formatCurrency({ value: Math.abs(investorInfo?.totalInvestedValue), locale, currencyCode })}` : `${formatCurrency({ value: investorInfo?.totalInvestedValue, locale, currencyCode })}`) : `${formatCurrency({ value: 0, locale, currencyCode })}`
        },
        {
            label: "Invested Value (Thriveiti)",
            value: investorInfo?.clientInvestedValue ? (investorInfo?.clientInvestedValue < 0 ? `- ${formatCurrency({ value: Math.abs(investorInfo?.clientInvestedValue), locale, currencyCode })}` : `${formatCurrency({ value: investorInfo?.clientInvestedValue, locale, currencyCode })}`) : `${formatCurrency({ value: 0, locale, currencyCode })}`
        },
        {
            label: "Invested Value (External)",
            value: investorInfo?.externalInvestedValue ? (investorInfo?.externalInvestedValue < 0 ? `- ${formatCurrency({ value: Math.abs(investorInfo?.externalInvestedValue), locale, currencyCode })}` : `${formatCurrency({ value: investorInfo?.externalInvestedValue, locale, currencyCode })}`) : `${formatCurrency({ value: 0, locale, currencyCode })}`
        },
    ]

    const tableHeaderData: TableHeaderData[] = [
        {
            id: "schemeName",
            label: "SCHEME NAME",
            align: "left",
            isSortable: true,
            key: 'schemeName'
        },
        {
            id: "status",
            label: "STATUS",
            align: "center",
            isSortable: false,
            key: 'status'
        },
        {
            id: "buySellType",
            label: "TRANSACTION TYPE",
            align: "center",
            isSortable: false,
            key: 'buySellType'
        },
        {
            id: "recommendedAmount",
            label: "AMOUNT",
            align: "center",
            isSortable: true,
            key: 'recommendedAmount'
        },
        {
            id: "recommendedUnits",
            label: "UNITS",
            align: "center",
            isSortable: true,
            key: 'recommendedUnits'
        },
        {
            id: "recommendedDate",
            label: "DATE",
            align: "center",
            isSortable: true,
            key: 'recommendedDate'
        }
    ]

    const riskToleranceMapper = {
        "defensive": theme.palette.success[500],
        "conservative": theme.palette.warning[500],
        "moderate": theme.palette.warning[800],
        "balanced": theme.palette.customColors.riskScoreOrange,
        "dynamic": theme.palette.customColors.riskScoreRed,
        "default": theme.palette.primary[500]
    }


    const handleTableSorting = async (orderBy: string, order: Order) => {
        try {
            setSortingObj({ order, orderBy })
            recommendationsTableData(order, orderBy, selectedPortfolio?.value)
        } catch (e) {
            console.log("Error: ", e)
        }
    }

    const style: any = { color: palette.text.secondary, fontWeight: 500, fontSize: '14px', textTransform: 'uppercase', textWrap: 'nowrap', paddingRight: 0, paddingLeft: 0 }

    const handleAssetClassNavigation = (index: number) => {
        dispatch(setRecommendationsActiveCategories({
            primaryCategory: "New Purchase",
            secondaryCategory: "Lumpsum"
        }))
        dispatch(setSelectedAllHoldingsInfo([]))
        dispatch(setAppliedRecommendationsFilters([]))

        dispatch(setAppliedHoldingsFilters([]))
        dispatch(setHoldingsActiveCategory("All"))
        dispatch(setSelectedHoldingsIds([]))
        dispatch(setCheckedHoldingSchemes([]))
        dispatch(setSelectedHoldingsInfo([]))



        if (index === 0) {
            history.push(`${pathName}/mutual-fund?tab=Overview&portfolio=${selectedPortfolio?.value ?? ""}`, {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
            });
        }
        else if (index === 1) {
            history.push(`${pathName}/debt?tab=Overview`, {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
            });
            // window.open(`${BONDS_LINK}`, '_blank');
        }
        else if (index === 2) {
            history.push(`${pathName}/pms?tab=Overview`, {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
            });
        }
        else if (index === 3) {
            history.push(`${pathName}/alternates?tab=Overview`, {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
            });
        }
        else if (index === 4) {
            history.push(`${pathName}/direct-equity?tab=Overview`, {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
            });
        }
    }

    const initialRouter = pathName.split('/').filter((item) => item !== '')

    const routerPath = [
        {
            name: 'Dashboard',
            path: '/dashboard',
            state: {
                accountFilter: navState?.accountFilter,
            },
            handleClick: () => {
                dispatch(storeSelectedPortfolio({
                    label: '',
                    value: ''
                }))
                dispatch(storePortfolioList([]))
            }
        },
        {
            name: `${initialRouter[1]}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
            }
        },
    ]

    const investorRouterPath = [
        ...(familyMemberId ? [{
            name: 'View Family',
            path: `/investor-family/family-profile/${familyMemberId}`,
        }, {
            name: `${initialRouter[1]}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
        }] : [])
    ]

    const { getCurrentStack } = useRoleStack();

    // console.log('invStack', getCurrentStack());


    const handleHeader = () => {
        setTableHeaderMenu(true)
    }

    const handleHeaderDropdownChange = async (value: string | number) => {
        await callInvestorInfo(`${value}`);
    }

    const handlePortfolioChange = async (value: string | number) => {
        setPortfolioDropdownOptions(`${value}`);
        await fetchPortfolioAllocation(selectedPortfolio?.value, Number(value), `${investorRmId ?? ""}`);
    }

    const handleAssetDropdownChange = async (value: string | number,) => {
        setAssetDropdownOptions(`${value}`);
        await fetchAssetAllocation(selectedPortfolio?.value, Number(value), `${investorRmId ?? ""}`);
    }

    const openEditRiskProfile = () => {
        // setOpenRiskScore(true);
        history.push(`${pathName}/edit-risk-profile`, {
            clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
        })
    }

    const closeEditRiskProfile = () => {
        setOpenRiskScore(false);
    }

    const handleEcasDownloads = () => {
        history.push(`${pathName}/mutual-fund/ecas-reports`, {
            clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
        })
    }

    const handleExploreMutualFunds = () => {

        dispatch(setSelectedAllHoldingsInfo([]))

        dispatch(setAppliedFundsFilters([]));
        dispatch(setSelectedSchemesObj({}));
        dispatch(setExploreMutualFundsPageVisited(false));

        dispatch(setAppliedHoldingsFilters([]))
        dispatch(setHoldingsActiveCategory("All"))
        dispatch(setSelectedHoldingsIds([]))
        dispatch(setCheckedHoldingSchemes([]))
        dispatch(setSelectedHoldingsInfo([]))

        dispatch(setSystematicPlansSearchText(""))
        dispatch(setAppliedSystematicPlansFilters([]))
        history.push(`${pathName}/mutual-fund/explore`, {
            clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId,
            // hideCheckBox: false
        })
    }

    const handleTransactDropdownOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setTransactDropdownEl(event.currentTarget);
    };

    const handleTransactDropdownClose = () => {
        setTransactDropdownEl(null);
    };

    const handleTransactDropdownItemsClick = (currentItem: { path: string, title: string }) => {
        if (investorInfo?.portfolio?.isPortfolioHeldaway) {
            dispatch(showError(HELDAWAY_PORTFOLIO_STATUS))
            setTransactDropdownEl(null);
            return
        }

        setTransactDropdownEl(null);

        history.push(`${pathName}/mutual-fund${currentItem.path}`, {
            clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId,
        });

    }

    const isTransactDropdownOpen = Boolean(transactDropdownEl);

    const handleMfcNotificationClick = () => {

        const heldAwayPortfolioObj = (investorInfo?.portfolioList ?? []).find(obj => obj.isPortfolioHeldaway)

        if (heldAwayPortfolioObj) {
            history.push(`${pathName}/mutual-fund?tab=Overview&portfolio=${heldAwayPortfolioObj?.portfolioId ?? ""}`, {
                clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
            });
        }
    }

    const closeExpiringMandateDialog = () => {
        dispatch({
            type: "SET_EXPIRING_MANDATE_STATUS",
            payload: true
        })
        setExpiringMandateDialog(false);
    }

    const handleAuthenticateClick = () => {
        if (pendingMandateData?.mandate?.bseEmandateURL) {
            window.open(`${pendingMandateData?.mandate?.bseEmandateURL}`, '_blank')
        }
        closeExpiringMandateDialog();
    }

    const handleToggleChange = async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        try {
            setToggleLoading(true)

            if (checked) {
                const response = await (dispatch(getPortfolioXirr({
                    rmId: `${iwappRmId}`,
                    clientCode: isRMLikeRole(role) ? navState?.clientCode ?? "" : investorClientId,
                    portfolioId: selectedPortfolio?.value || navState?.portfoiloId || "",
                })) as unknown as Promise<GetPortfolioXirrResponseBody>)

                if (!response?.isSuccess) {
                    dispatch(showError(response?.message ?? ""))
                    return
                }

                if (response?.isSuccess) {
                    setToggleIrr(checked)
                    setToggleValue(Number(response?.xirr ?? ""))
                }
            } else {
                const response = await fetchInvestorInfoApi({
                    clientCode: isRMLikeRole(role) ? navState?.clientCode ?? "" : investorClientId,
                    portfolio: selectedPortfolio?.value || navState?.portfoiloId || "",
                    applicationId: applicationId,
                    rmId: `${iwappRmId}`,
                })

                if (response.isSuccess) {
                    setToggleIrr(checked)
                    setToggleValue(Number(response?.return ?? ""))
                }
            }

        } catch (e) {
            console.log("Error: ", e)
        } finally {
            setToggleLoading(false)
        }
    }

    const handleViewAllNotificationsClick = () => {
        history.push(`${pathName}/notifications`, {
            clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
        })
    }

    const isMinor = isOnboardingTypeMinor(investorInfo?.application?.onboardingType || '');
    const investorName = isMinor ? `${investorInfo?.application?.applicants?.[0]?.minorFirstName} ${investorInfo?.application?.applicants?.[0]?.minorLastName}` : investorInfo?.name;

    const guardianName = isMinor ? `${investorInfo?.application?.applicants?.[0]?.name}` : '';

    const isNIO = [APPLICATION_TYPE.NON_INDIVIDUAL].includes((investorInfo?.application?.applicationType ?? "") as APPLICATION_TYPE)

    return (
        <>
            <Backdrop
                sx={(theme: Theme) => ({
                    color: theme.palette.common.white,
                    zIndex: theme.zIndex.drawer + 1
                })}
                open={isToggleLoading}
            >
                <CircularProgress sx={(theme: Theme) => ({ color: theme.palette.primary[500] })} />
            </Backdrop>
            <Box>
                {/* Custom Dropdown */}
                <Box component={'section'} sx={{ display: 'flex', justifyContent: 'space-between', mb: '15px', flexWrap: 'wrap', flexDirection: 'row', }} >
                    <BreadCrum array={isRMLikeRole(role) ? routerPath : investorRouterPath} />

                    {investorPortfolioOptions.length > 0
                        &&
                        (
                            <Box>
                                <CustomDropdown selectedValue={selectedPortfolio?.value} dropdownOptions={investorPortfolioOptions} handleValueChange={handleHeaderDropdownChange} isLoading={investorInfoLoading} />
                            </Box>
                        )
                    }
                </Box>
                {role === "investor" && (
                    investorInfoLoading ? (
                        <Skeleton animation="wave" variant="text" width={200} height={20} />
                    ) : (
                        <Typography
                            variant={familyMemberId ? "body_600" : 'h1'}
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                            })}
                        >
                            {`Dashboard ${familyMemberId ? `(${investorName})` : ''}`}
                        </Typography>
                    )
                )}
                <Box
                    sx={{
                        display: "flex",
                        marginBottom: "15px",
                        columnGap: "25px",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        mb: '15px'
                    }}
                >
                    {investorInfoLoading && (
                        <>
                            {/* <Skeleton
                                animation="wave"
                                variant="rectangular"
                                width={100}
                                height={25}
                            /> */}
                            <Skeleton
                                animation="wave"
                                variant="rectangular"
                                width={100}
                                height={25}
                            />
                        </>
                    )}
                    {(
                        !investorInfo?.portfolio?.isPortfolioHeldaway &&
                        !investorInfoLoading
                    ) && (
                            <>
                                {/* {isMfcReportVisible && (
                                    <Button
                                        variant="outlined"
                                        onClick={handleEcasDownloads}
                                        sx={(theme: Theme) => ({
                                            ...theme.typography.subtitle_300,
                                            fontWeight: 700,
                                            borderRadius: "10px",
                                            border: `1px solid ${theme.palette.primary[500]}`,
                                            color: theme.palette.primary[500],
                                            padding: "0.5rem 0.8rem",
                                            "&.Mui-disabled": {
                                                backgroundColor: `${theme.palette.text.secondary}B2`,
                                                color: theme.palette.text.secondary,
                                            },
                                        })}
                                        disabled={investorInfoLoading || isFamilyView}
                                    >
                                        Import External Funds
                                    </Button>
                                )} */}
                                <Button
                                    id="transact-button"
                                    aria-controls={isTransactDropdownOpen ? 'transact-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={isTransactDropdownOpen ? 'true' : undefined}
                                    onClick={handleTransactDropdownOpen}
                                    endIcon={<WhiteDropDownIcon />}
                                    variant="contained"
                                    sx={(theme: Theme) => ({
                                        ...theme.typography.subtitle_300,
                                        fontWeight: 700,
                                        borderRadius: "10px",
                                        padding: "0.5rem 0.8rem",
                                        backgroundColor: theme.palette.primary[500],
                                        color: theme.palette.textDark.primary,
                                        maxWidth: '250px',
                                        width: { xs: "100px", sm: "172px" },
                                        "&.Mui-disabled": {
                                            backgroundColor: `${theme.palette.text.secondary}B2`,
                                            color: theme.palette.text.secondary,
                                        },
                                        flexWrap: 'nowrap',
                                    })}
                                    disabled={([USER_ROLES.INVESTOR].includes(role) && !isPortfolioAvailable) || investorInfoLoading || isFamilyView}
                                >
                                    Transact
                                </Button>
                            </>
                        )}

                </Box>
                <Menu
                    id="transact-menu"
                    anchorEl={transactDropdownEl}
                    open={isTransactDropdownOpen}
                    onClose={handleTransactDropdownClose}
                    MenuListProps={{
                        'aria-labelledby': 'transact-button',
                        sx: {
                            '& > :not(:last-child)': {
                                marginBottom: { xs: '0px', sm: '5px' },
                            }
                        }
                    }}
                    slotProps={{
                        paper: {
                            sx: (theme: Theme) => ({
                                width: { xs: '100px', sm: '180px' },
                                borderRadius: "12px",
                                paddingLeft: { xs: "8px", sm: "9px" },
                                paddingRight: "8px",
                                backgroundColor: palette.common.white
                            })
                        }
                    }}
                >
                    {transactDropdownItems
                        .map((item): JSX.Element =>
                            <MenuItem
                                key={item.title}
                                onClick={() => handleTransactDropdownItemsClick(item as { path: string; title: string; })}
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.secondary,
                                    padding: { xs: "6px", sm: "8px" },
                                    minHeight: "auto",
                                    ...theme.typography.body_500,
                                    whiteSpace: { xs: 'normal', sm: 'nowrap' },
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary[100],
                                        borderRadius: "8px",
                                        color: theme.palette.primary[500]
                                    },
                                })}
                            >
                                {item.title}
                            </MenuItem>
                        )}
                </Menu>

                {/* User Profile and Risk Score */}
                <Grid container columnSpacing={'25px'}>

                    {/* User Profile and Cards */}
                    <Grid item md={12} lg={isNIO ? 12 : 8}>
                        <Box component={'section'} sx={(theme: Theme) => ({ borderRadius: '25px', padding: { xs: '15px', sm: '35px' }, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)', background: theme.palette.common.white })}>

                            {/* User Profile */}
                            {investorInfoLoading
                                ?
                                <Grid
                                    container
                                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: 0, rowGap: '10px' }}
                                >
                                    <Grid item lg={6} md={12}>
                                        {/* Investor Name */}
                                        <Box sx={{ display: 'flex', columnGap: '15px', mb: '35px' }}>
                                            <Skeleton animation="wave" variant="circular" width={58} height={58} />
                                            <Box >
                                                <Skeleton animation="wave" sx={{ width: '200px' }} />
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Skeleton animation="wave" sx={{ width: '50%' }} />
                                                    <Skeleton animation="wave" variant="circular" sx={{ width: '4px', height: '4px', ml: '3px', mr: '3px' }} />
                                                    <Skeleton animation="wave" sx={{ width: '50%' }} />
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Investor Details */}
                                        <Box component={'section'}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                <Skeleton animation="wave" variant="rectangular" sx={{ width: '15px', height: '15px' }} />
                                                <Skeleton animation="wave" sx={{ width: '120px' }} />
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                <Skeleton animation="wave" variant="rectangular" sx={{ width: '15px', height: '15px' }} />
                                                <Skeleton animation="wave" sx={{ width: '120px' }} />
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                                                <Skeleton animation="wave" variant="rectangular" sx={{ width: '15px', height: '15px' }} />
                                                <Skeleton animation="wave" sx={{ width: '120px' }} />
                                            </Box>

                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                        <Box sx={{ mb: { lg: '35px', xs: '10px' }, width: { xs: '100%' } }}>
                                            <Skeleton animation="wave" variant="text" sx={{ width: { xs: '100%' } }} />
                                            <Skeleton animation="wave" sx={{ width: { xs: '100%' } }} />
                                            <Skeleton animation="wave" height={'20px'} sx={{ width: { xs: '100%' } }} />
                                        </Box>
                                        <Box sx={{ display: 'flex', columnGap: '35px', flexDirection: 'row', width: { xs: '100%', } }}>
                                            <Box sx={{ width: { xs: '33%', sm: 'unset' } }}>
                                                <Skeleton animation="wave" sx={{ width: { xs: '80%', sm: '80px' } }} />
                                                <Skeleton animation="wave" sx={{ width: { xs: '100%', sm: '100px' } }} />
                                            </Box>
                                            <Box sx={{ width: { xs: '33%', sm: 'unset' } }}>
                                                <Skeleton animation="wave" sx={{ width: { xs: '80%', sm: '80px' } }} />
                                                <Skeleton animation="wave" sx={{ width: { xs: '100%', sm: '100px' } }} />
                                            </Box>
                                            <Box sx={{ width: { xs: '33%', sm: 'unset' } }}>
                                                <Skeleton animation="wave" sx={{ width: { xs: '80%', sm: '80px' } }} />
                                                <Skeleton animation="wave" sx={{ width: { xs: '100%', sm: '100px' } }} />
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                                :
                                <Grid container sx={(theme: Theme) => ({ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: '30px', borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`, rowGap: '10px' })}>
                                    <Grid item md={7} sm={12}>
                                        {/* Investor Name */}
                                        <Box sx={{ display: 'flex', columnGap: '15px', mb: '35px' }}>
                                            <Box sx={(theme: Theme) => (
                                                {
                                                    backgroundColor: theme.palette.primary[300],
                                                    borderRadius: '50%',
                                                    width: '58px',
                                                    height: '58px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }
                                            )}>
                                                <Typography variant="h1" sx={(theme: Theme) => ({
                                                    fontSize: '24px',
                                                    letterSpacing: '0.02px',
                                                    padding: '14px 14px 14px 12px',
                                                    color: theme.palette.primary[500]
                                                })}>{getAbbreviatedName(investorName)}</Typography>
                                            </Box>

                                            <Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography variant="h1" component="span" color='text.primary' sx={{ whiteSpace: 'nowrap', fontWeight: 600, fontSize: { xs: '18px', sm: '20px', md: '22px' } }}>{investorName}</Typography>
                                                    {maskedData
                                                        ?
                                                        <IconButton
                                                            aria-label="Show masked data"
                                                            sx={{
                                                                '&:hover': {
                                                                    backgroundColor: 'transparent'
                                                                }
                                                            }}
                                                            onClick={() => setMaskedData(!maskedData)}
                                                        >
                                                            <HideIcon stroke={palette.primary[500]} />
                                                        </IconButton>
                                                        :
                                                        <IconButton
                                                            aria-label="Hide sensitive data"
                                                            sx={{
                                                                '&:hover': {
                                                                    backgroundColor: 'transparent'
                                                                }
                                                            }}
                                                            onClick={() => setMaskedData(!maskedData)}
                                                        >
                                                            <ViewIcon stroke={palette.primary[500]} />
                                                        </IconButton>
                                                    }
                                                </Box>
                                                {/* {ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD && (
                                                <Box sx={{ marginTop: "3px" }}>
                                                    <Typography
                                                        component='span'
                                                        variant="body_500"
                                                        color='text.secondary'
                                                        sx={{ mr: '10px' }}
                                                    >
                                                        Account Type: {MPOWER_ACCOUNT_TYPE_MASTER[investorInfo?.portfolio?.portfolioAccountType ?? ""]}
                                                    </Typography>
                                                </Box>
                                            )} */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', marginTop: "3px" }}>
                                                    <Typography component={'span'} variant="body_500" color='text.secondary' sx={{ mr: '10px' }}>{investorInfo?.investorType}</Typography>
                                                    <Box component={'span'}
                                                        sx={{
                                                            borderRadius: '20%', width: '4px', height: '4px', mr: '10px', backgroundColor: 'text.secondary',
                                                        }} />
                                                    <Button
                                                        onClick={() => history.push(`${pathName}/view-profile`, {
                                                            // clientCode: navState?.clientCode || "",
                                                            clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId
                                                        })}
                                                        aria-label="View Profile"
                                                        sx={(theme: Theme) => (
                                                            {
                                                                color: theme.palette.customColors.subtitle,
                                                                padding: 0,
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.common.white,
                                                                    '& .view-profile-icon': {
                                                                        transform: 'rotate(-45deg)',
                                                                        transition: 'transform 0.3s ease', // Smooth transition for rotation
                                                                    }
                                                                }

                                                            }
                                                        )}>
                                                        <Typography variant="body_500" sx={{
                                                            letterSpacing: '0.01px',
                                                        }}>
                                                            View Profile
                                                        </Typography>
                                                        <ViewProfileIcon className="view-profile-icon" stroke={palette.customColors.subtitle} />
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item md={5} sm={12}>
                                        <Box component={'div'} sx={{ display: { sm: 'flex', md: 'block' }, justifyContent: { sm: 'space-between', xl: 'normal' }, mb: { xs: '10px' }, textAlign: { sm: 'left', md: 'right' } }}>
                                            <Box>
                                                <Typography variant="body_500" color='text.primary'>Market Value</Typography>
                                                <Typography variant="subtitle_500" color="text.secondary">{`as on ${formattedBusinessDate}`}</Typography>
                                            </Box>

                                            <Typography variant="h1" sx={(theme: Theme) => ({
                                                color: maskedData ? theme.palette.text.primary : theme.palette.primary[500],
                                                lineHeight: '40px',
                                                mt: '5px'
                                            })}>
                                                {maskedData ? '****' : toINR({ value: investorInfo?.marketValue, locale, currencyCode })}
                                            </Typography>

                                        </Box>
                                    </Grid>
                                    {/* Investor Details */}
                                    <Grid container item xs={12} lg={6} flexDirection="column">
                                        <Grid item>
                                            <Box component={'section'} sx={{ display: { lg: 'block', xs: 'flex' }, flexDirection: { xs: 'column', lg: 'column' }, flexWrap: 'wrap', alignItems: { xs: 'flex-start', lg: 'center' }, justifyContent: 'flex-start', gap: { xs: '5px', sm: '10px' } }}>
                                                {investorInfo?.investorType === 'Joint' && (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: { xs: '0.5px', sm: '15px' } }}>
                                                        <JointHoldersDisplayIcon />
                                                        {investorInfo?.applicantNames.map((name: string, index: number) => (
                                                            <Typography
                                                                key={index}
                                                                component={'span'}
                                                                variant="body_500"
                                                                color='text.primary'
                                                                sx={{ letterSpacing: '0.02px', textTransform: 'capitalize' }}
                                                            >
                                                                {name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}
                                                                {index === 0 && investorInfo?.applicantNames?.length > 1 && ','}
                                                            </Typography>
                                                        ))}
                                                    </Box>
                                                )}
                                                {guardianName && (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                        <Typography
                                                            component={'span'}
                                                            variant="body_500"
                                                            color='text.primary'
                                                            sx={{ letterSpacing: '0.02px', textTransform: 'capitalize' }}
                                                        >
                                                            {`Guardian Name:- ${guardianName}`}
                                                        </Typography>
                                                    </Box>
                                                )}
                                                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                    <EmailIcon />
                                                    <Typography component={'span'} variant="body_500" color='text.primary' sx={{ letterSpacing: '0.02px' }}>{investorInfo?.emailId}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                    <Phoneicon />
                                                    <Typography component={'span'} variant="body_500" color='text.primary' sx={{ letterSpacing: '0.02px' }}>{`+91 ${investorInfo?.mobileNumber}`}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px', mb: '15px' }}>
                                                    <Typography component={'span'} variant="body_500" color='text.primary' sx={{ letterSpacing: '0.02px' }}>{`Client Code: ${investorInfo?.clientCode ?? "-"}`}</Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '0px', mb: '0.5px' }}>
                                                    {/* <JointHolderIcon /> */}
                                                    <Typography component={'span'} variant="body_500" color='text.primary' sx={{ letterSpacing: '0.02px' }}>Support Details</Typography>
                                                    <Box>
                                                        <Tooltip
                                                            slotProps={{
                                                                popper: {
                                                                    modifiers: [
                                                                        {
                                                                            name: 'preventOverflow',
                                                                            options: {
                                                                                boundary: 'viewport',
                                                                                padding: 8,
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                                tooltip: {
                                                                    sx: {
                                                                        margin: "0px !important",
                                                                        backgroundColor: "transparent",
                                                                        maxWidth: { xs: '300px', sm: 'none' },
                                                                    }
                                                                }
                                                            }}
                                                            title={
                                                                <Box sx={{
                                                                    borderRadius: '10px',
                                                                    backgroundColor: theme.palette.customColors.cinder,
                                                                    padding: '10px',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    rowGap: '10px'
                                                                }}>
                                                                    {/* <Box>
                                                                    <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                        Name
                                                                    </Typography>
                                                                    <Typography variant='subtitle_600'>
                                                                        {investorInfo?.rm ?? '-'}
                                                                    </Typography>
                                                                </Box> */}
                                                                    <Box>
                                                                        <Typography variant='overline_400' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                            Email Id
                                                                        </Typography>
                                                                        <Typography variant='body_500'>
                                                                            {/* {investorInfo?.rmDetails?.user?.email ?? '-'} */}
                                                                            support@thriveiti.com
                                                                        </Typography>
                                                                    </Box>
                                                                    {/* <Box>
                                                                    <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                        Phone No.
                                                                    </Typography>
                                                                    <Typography variant='subtitle_600'>
                                                                        {investorInfo?.rmDetails?.user?.phone ?? '-'}
                                                                    </Typography>
                                                                </Box> */}

                                                                </Box>
                                                            }
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        '@media (pointer: coarse)': {
                                                                            touchAction: 'none',
                                                                            position: 'fixed',
                                                                            zIndex: 9999
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            disableInteractive={false}
                                                            enterTouchDelay={0}
                                                            leaveTouchDelay={3000}
                                                        >
                                                            <IconButton
                                                                aria-label="View RM details"
                                                                sx={{
                                                                    '@media (pointer: coarse)': {
                                                                        padding: '12px'
                                                                    }
                                                                }}
                                                            >
                                                                <InfoIconOutlined />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid
                                            item
                                            container
                                            sx={{
                                                flexDirection: "row",
                                                alignItems: 'center',
                                                justifyContent: 'flex-start',
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    columnGap: '10px',
                                                    // marginBottom: { xs: '5px', lg: '10px' }
                                                }}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    color='text.primary'
                                                    sx={{ letterSpacing: '0.02px' }}
                                                >
                                                    MF Transaction Status:
                                                </Typography>
                                                <Typography
                                                    variant="body_500"
                                                    color={bseStarStatusColorMap[`${investorInfo?.bseClientActivationStatus ?? ""}`.toLowerCase()] ?? 'text.primary'}
                                                    sx={{
                                                        letterSpacing: '0.02px',
                                                        textTransform: "capitalize"
                                                    }}
                                                >
                                                    {investorInfo?.bseClientActivationStatus ?? 'N/A'}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Tooltip
                                                    slotProps={{
                                                        popper: {
                                                            modifiers: [
                                                                {
                                                                    name: 'preventOverflow',
                                                                    options: {
                                                                        boundary: 'viewport',
                                                                        padding: 8,
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        tooltip: {
                                                            sx: {
                                                                margin: "0px !important",
                                                                backgroundColor: "transparent",
                                                                maxWidth: { xs: '300px', sm: 'none' },
                                                            }
                                                        }
                                                    }}
                                                    title={
                                                        <Box sx={{
                                                            borderRadius: '10px',
                                                            backgroundColor: '#0F131F',
                                                            padding: '10px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            rowGap: '10px',
                                                            maxHeight: { xs: '70vh', sm: 'none' },
                                                            overflowY: 'auto'
                                                        }}>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    CLIENT CREATION RESPONSE
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.acceptedByBseStar ? 'SUCCESS' : investorInfo?.bseStarResponse ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    FATCA RESPONSE
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.acceptedByBseStarFatca ? 'SUCCESS' : investorInfo?.bseFatcaResponse ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    CHEQUE UPLOAD RESPONSE
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.cancelChequeUploadAcceptedByBseStar ? 'SUCCESS' : investorInfo?.cancelChequeUploadResponse ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    AOF IMAGE RESPONSE
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.aofImageUploadAcceptedByBseStar ? 'SUCCESS' : investorInfo?.bseAofImageResponse ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    MPOWER STATUS
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.acceptedByMpower ? 'SUCCESS' : investorInfo?.mpowerResponse ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    ELOG STATUS
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.elogStatus ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    ELOG STATUS APPLICANT 1
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.elogResponse1 === '' ? '-' : investorInfo?.elogResponse1 ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    ELOG STATUS APPLICANT 2
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.elogResponse2 === '' ? '-' : investorInfo?.elogResponse2 ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                                    ELOG STATUS APPLICANT 3
                                                                </Typography>
                                                                <Typography variant='subtitle_600'>
                                                                    {investorInfo?.elogResponse3 === '' ? '-' : investorInfo?.elogResponse3 ?? '-'}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    }
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                '@media (pointer: coarse)': {
                                                                    touchAction: 'none',
                                                                    position: 'fixed',
                                                                    zIndex: 9999
                                                                }
                                                            }
                                                        }
                                                    }}
                                                    disableInteractive={false}
                                                    enterTouchDelay={0}
                                                    leaveTouchDelay={3000}
                                                >
                                                    <IconButton
                                                        aria-label="View ELOG status details"
                                                        sx={{
                                                            '@media (pointer: coarse)': {
                                                                padding: '12px'
                                                            }
                                                        }}
                                                    >
                                                        <InfoIconOutlined />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                            {/* <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                columnGap: '10px',
                                            }}
                                        >
                                            <Typography
                                                variant="body_500"
                                                color='text.primary'
                                                sx={{ letterSpacing: '0.02px' }}
                                            >
                                                MPower Status:
                                            </Typography>
                                            <Typography
                                                variant="body_500"
                                                color={investorInfo?.acceptedByMpower ? 'success.500' : 'warning.500'}
                                                sx={{ letterSpacing: '0.02px' }}
                                            >
                                                {investorInfo?.acceptedByMpower ? 'Active' : 'Pending'}
                                            </Typography>
                                        </Box>  */}
                                        </Grid>
                                    </Grid>


                                    <Grid item xs={12} lg={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: { xs: 'flex-start', lg: 'flex-end' },
                                                rowGap: "30px"
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Typography
                                                    variant="subtitle_500"
                                                    color="text.primary"
                                                    onClick={() => { if (isToggleIrr) handleToggleChange({} as React.ChangeEvent<HTMLInputElement>, false); }}
                                                    sx={{ cursor: 'pointer' }}
                                                >
                                                    Absolute Return
                                                </Typography>
                                                <Switch
                                                    checked={isToggleIrr}
                                                    onChange={handleToggleChange}
                                                    onKeyDown={(e: React.KeyboardEvent) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            handleToggleChange({} as React.ChangeEvent<HTMLInputElement>, !isToggleIrr);
                                                        }
                                                    }}
                                                    inputProps={{ 'aria-label': 'Toggle between Absolute Return and XIRR' }}
                                                    sx={(theme: Theme) => ({
                                                        transform: {
                                                            xs: "scale(0.7)",
                                                            md: "scale(0.9)",
                                                            lg: "scale(1)"
                                                        },
                                                        "& .MuiSwitch-switchBase, & .MuiSwitch-switchBase.Mui-checked": {
                                                            color: theme.palette.primary[500],
                                                        },
                                                        "& .MuiSwitch-track, & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                            backgroundColor: theme.palette.primary[500],
                                                        },
                                                    })}
                                                />
                                                <Typography
                                                    variant="subtitle_500"
                                                    color="text.primary"
                                                    onClick={() => { if (!isToggleIrr) handleToggleChange({} as React.ChangeEvent<HTMLInputElement>, true); }}
                                                    sx={{ cursor: 'pointer' }}
                                                >
                                                    XIRR
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', columnGap: { xs: '50px', sm: '20px' }, justifyContent: { xs: 'flex-start', lg: 'flex-end' } }}>
                                                <Box>
                                                    <Typography variant="subtitle_500" color="text.primary" sx={{ textAlign: { md: 'left', lg: 'right' } }}>Invested Value</Typography>
                                                    {maskedData ?
                                                        <Typography variant="h2" sx={(theme: Theme) => ({ color: theme.palette.text.primary, textAlign: 'center' })}>****</Typography>
                                                        :
                                                        <Typography variant="h2" sx={(theme: Theme) => ({
                                                            color: investorInfo?.investedValue > -1 ? theme.palette.success[500] : theme.palette.error[500],
                                                            fontSize: { xs: '14px', md: '16px', lg: '20px' },
                                                            textWrap: 'nowrap'
                                                        })}>
                                                            {investorInfo?.investedValue === 0 ? `${toINR({ value: investorInfo?.investedValue, locale, currencyCode })}` : investorInfo?.investedValue > 0 ? `${formatCurrency({ value: investorInfo?.investedValue, locale, currencyCode })}` : `- ${formatCurrency({ value: Math.abs(investorInfo?.investedValue), locale, currencyCode })}`
                                                            }
                                                        </Typography>
                                                    }
                                                </Box>
                                                <Box>
                                                    <Typography variant="subtitle_500" color="text.primary" sx={{ textAlign: { md: 'left', lg: 'center' } }}>Gain/Loss</Typography>
                                                    {maskedData
                                                        ?
                                                        <Typography variant="h2" sx={(theme: Theme) => ({ color: theme.palette.text.primary, textAlign: 'center' })}>****</Typography>
                                                        : <Typography variant="h2" sx={(theme: Theme) => ({
                                                            color: investorInfo?.["gain/loss"] > -1 ? theme.palette.success[500] : theme.palette.error[500],
                                                            fontSize: { xs: '14px', md: '16px', lg: '20px' },
                                                            textWrap: 'nowrap'
                                                        })}>
                                                            {investorInfo?.["gain/loss"] === 0 ? `${toINR({ value: investorInfo?.["gain/loss"], locale, currencyCode })}` : investorInfo?.["gain/loss"] > 0 ? `+ ${formatCurrency({ value: investorInfo?.["gain/loss"], locale, currencyCode })}` : `- ${formatCurrency({ value: Math.abs(investorInfo?.["gain/loss"]), locale, currencyCode })}`
                                                            }
                                                        </Typography>}
                                                </Box>
                                                <Box>
                                                    <Typography variant="subtitle_500" color="text.primary" sx={{ textAlign: { md: 'left', lg: 'center' } }}>
                                                        {isToggleIrr ? "XIRR" : "Absolute Return"}
                                                    </Typography>
                                                    {maskedData
                                                        ?
                                                        <Typography variant="h2" sx={(theme: Theme) => ({ color: theme.palette.text.primary, textAlign: 'center' })}>****</Typography>
                                                        : <Typography variant="h2" sx={(theme: Theme) => ({
                                                            color: Number(toggleValue ?? "") >= 0 ? theme.palette.success[500] : theme.palette.error[500],
                                                            fontSize: { xs: '14px', md: '16px', lg: '20px' },
                                                            textWrap: 'nowrap'
                                                        })}>
                                                            {Number(toggleValue ?? "") === 0 ? '0%' : `${Number(toggleValue ?? "").toFixed(2)}%`}
                                                        </Typography>}
                                                </Box>
                                            </Box>
                                        </Box>

                                    </Grid>
                                </Grid>
                            }


                            {/* Asset Classes */}

                            <Box sx={{
                                mt: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                // justifyContent: { lg: "space-between", xs: "flex-start" },
                                flexWrap: "wrap"
                            }}>
                                {assestPercentages?.map((item, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <Button
                                                sx={(theme: Theme) => ({
                                                    maxWidth: "fit-content",
                                                    flex: "1 1 auto",
                                                    padding: '5px 10px',
                                                    borderRadius: '5px',
                                                    '&:hover': {
                                                        backgroundColor: assetClassLoader || investorInfoLoading ? 'unset' : theme.palette.primary[100],
                                                    },
                                                    '&:disabled': {
                                                        opacity: 0.5,
                                                        cursor: "not-allowed",
                                                        pointerEvents: "all"
                                                    }
                                                })}
                                                onClick={assetClassLoader || investorInfoLoading ? () => { '' } : () => handleAssetClassNavigation(index)}
                                                disabled={!investorInfo?.isSuccess || assetClassLoader || investorInfoLoading || !item?.is_holdings_available}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        columnGap: "5px",
                                                        alignItems: 'center',
                                                        '& svg path': {
                                                            fill: '#b5441c',
                                                            stroke: '#b5441c',
                                                        }
                                                    }}
                                                >
                                                    <Box>
                                                        {(assetClassLoader || investorInfoLoading) ? <Skeleton animation="wave" variant="rectangular" height={20} width={20} sx={{ borderRadius: '5px' }} /> : assetClassIconMap[index]}
                                                    </Box>
                                                    {(assetClassLoader || investorInfoLoading) ? <Skeleton animation="wave" sx={{ width: '80px' }} /> : <Typography
                                                        variant="body_500"
                                                        color="text.secondary"
                                                        sx={(theme: Theme) => ({
                                                            letterSpacing: '0.05px',
                                                            '&:hover': {
                                                                color: theme.palette.primary[500],

                                                            }
                                                        })}
                                                    >
                                                        {item.name}
                                                    </Typography>}
                                                </Box>
                                                {maskedData && !(assetClassLoader || investorInfoLoading)
                                                    ?
                                                    <Typography variant="body_600" sx={(theme: Theme) => ({
                                                        color: theme.palette.text.primary,
                                                        mt: 1
                                                    })}
                                                    >
                                                        **
                                                    </Typography>
                                                    :
                                                    (assetClassLoader || investorInfoLoading)
                                                        ? <Skeleton animation="wave" variant="rectangular" width={15} height={15} sx={{ ml: '10px' }} />
                                                        :
                                                        <>
                                                            {/* {index !== 1 && (investedValueCheck
                                                                ?
                                                                <ZeroStateArrow />
                                                                : item.value < 0
                                                                    ? <DownwardNegativeIcon />
                                                                    : <UpWardPositiveIcon />
                                                            )} */}
                                                            {item.value < 0
                                                                ? <DownwardNegativeIcon />
                                                                : <UpWardPositiveIcon />
                                                            }
                                                            {(!investedValueCheck) &&
                                                                <Typography
                                                                    variant="body_500"
                                                                    sx={(theme: Theme) => ({
                                                                        color: (investedValueCheck) ? theme.palette.text.primary : item.value < 0 ? theme.palette.error[500] : theme.palette.success[500],
                                                                    })}
                                                                >
                                                                    {item.value}%
                                                                </Typography>
                                                            }
                                                        </>
                                                }
                                            </Button>
                                            {assetClassLoader || investorInfoLoading
                                                ?
                                                <Skeleton animation="wave" height={30} width={5} sx={{ display: index !== 4 ? 'block' : 'none', }} />
                                                : <Box
                                                    sx={(theme: Theme) => ({
                                                        height: '15px',
                                                        width: "1px",
                                                        backgroundColor: `${theme.palette.text.secondary}B2`,
                                                        display: index !== 4 ? 'block' : 'none',
                                                    })}
                                                />
                                            }
                                        </React.Fragment>

                                    )
                                })}
                            </Box>
                        </Box>

                        {/* Three Cards */}

                        <Box columnGap={2} rowGap={2} mt={'25px'}
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                flexWrap: 'unwrap',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            {investorPortfolioCards.map((item, index) => {
                                return (
                                    <Box key={index} sx={(theme: Theme) => ({
                                        borderRadius: '15px',
                                        padding: { xs: "15px 18px", sm: "25px 18px" },
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                        background: theme.palette.common.white,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        width: '100%',
                                    })}>
                                        <Box>
                                            {investorInfoLoading ? <Skeleton animation="wave" variant="rectangular" width={40} height={40} sx={{ borderRadius: '10px' }} /> : index === 0 && <CashAvailablePortfolioIcon /> || index === 1 && <RupeeIcon /> || index === 2 && <RupeeIcon />}
                                        </Box>
                                        <Box sx={{ width: '100%' }}>
                                            {investorInfoLoading ?
                                                <Skeleton animation="wave" width="60%" />
                                                :
                                                <Typography color="text.primary"
                                                    sx={
                                                        {
                                                            mb: '5px',
                                                            fontWeight: 300,
                                                            fontSize: { xl: '16px', lg: '14px', md: '12px', sm: '14px', xs: '12px' },
                                                        }
                                                    }
                                                >
                                                    {item.label}
                                                </Typography>}
                                            {investorInfoLoading ?
                                                <Skeleton animation="wave" width="100%" />
                                                :
                                                maskedData ?
                                                    <Typography variant="h2" color="text.primary" sx={{ textAlign: 'left' }}>
                                                        ****
                                                    </Typography>
                                                    :
                                                    <Typography color="text.primary"
                                                        sx={
                                                            {
                                                                fontWeight: 600,
                                                                fontSize: { xl: '22px', lg: '16px', md: '16px', sm: '14px', xs: '12px' },
                                                            }
                                                        }
                                                    >
                                                        {item.value}
                                                    </Typography>

                                            }
                                        </Box>

                                    </Box>
                                    // </Box>
                                )
                            })}
                            {/* </Box> */}

                        </Box>

                    </Grid >

                    {/* Risk Score */}
                    {
                        !isNIO &&
                        (
                            < Grid item md={12} lg={4} sx={{ mt: { xs: '25px', lg: '0' }, width: '100%', }
                            }>
                                <Box component={'section'} sx={(theme: Theme) => ({ borderRadius: '25px', padding: '35px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)', background: theme.palette.common.white, height: "100%" })}>
                                    {riskScoreLoading && (
                                        // <>
                                        //     <Skeleton animation="wave" sx={{ width: '50%', height: '40px' }} />
                                        //     <Box sx={{ mt: { xl: '40px', xs: '20px' } }}>
                                        //         <Skeleton animation="wave" variant="circular" sx={{ width: '100%', height: '290px', mt: '35px' }} />
                                        //         <Box sx={{ textAlign: 'center', mt: '35px' }}>
                                        //             <Skeleton animation="wave" sx={{ width: '70%', textAlign: 'center' }} />
                                        //             <Skeleton animation="wave" sx={{ width: '50%' }} />
                                        //         </Box>
                                        //     </Box>
                                        // </>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                height: "100%",
                                                minHeight: { xs: "500px", lg: "0px" },
                                                rowGap: "15px"
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Skeleton
                                                    component="div"
                                                    animation="wave"
                                                    sx={(theme: Theme) => ({
                                                        width: "30%",
                                                        ...theme.typography.h2
                                                    })}
                                                />
                                                {/* {(isRMLikeRole(role)) && ( */}
                                                <Skeleton
                                                    component="div"
                                                    variant="circular"
                                                    animation="wave"
                                                    sx={{
                                                        width: "40px",
                                                        height: "40px"
                                                    }}
                                                />
                                                {/* )} */}
                                            </Box>
                                            <Box
                                                sx={{
                                                    flexGrow: 1,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Skeleton
                                                    component="div"
                                                    variant="circular"
                                                    animation="wave"
                                                    sx={{
                                                        width: { xs: "50%", lg: "65%" },
                                                        height: "100%"
                                                    }}
                                                />
                                            </Box>
                                            <Box
                                                sx={{
                                                    marginTop: "10px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    rowGap: "10px",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Skeleton
                                                    component="div"
                                                    animation="wave"
                                                    sx={(theme: Theme) => ({
                                                        width: "30%",
                                                        ...theme.typography.body_500
                                                    })}
                                                />
                                                <Skeleton
                                                    component="div"
                                                    animation="wave"
                                                    sx={(theme: Theme) => ({
                                                        width: "30%",
                                                        ...theme.typography.h1
                                                    })}
                                                />
                                                <Skeleton
                                                    component="div"
                                                    animation="wave"
                                                    sx={(theme: Theme) => ({
                                                        width: "50%",
                                                        ...theme.typography.body_400
                                                    })}
                                                />
                                            </Box>
                                        </Box>
                                    )}

                                    {!riskScoreLoading && (
                                        // <>
                                        //     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        //         <Typography variant="h2" color="text.primary" sx={{ letterSpacing: '0.01px', lineHeight: '25px' }}>
                                        //             Risk Score
                                        //         </Typography>
                                        //         {(isRMLikeRole(role)) && (
                                        //             // <IconButton onClick={openEditRiskProfile} sx={{ cursor: 'pointer', fontSize: '25px' }}>
                                        //             //     <BlueEditIcon />
                                        //             // </IconButton>
                                        //             <IconButton
                                        //                 sx={{
                                        //                     width: "40px",
                                        //                     height: "40px"
                                        //                 }}
                                        //             >
                                        //                 <CardMedia
                                        //                     component="img"
                                        //                     src="/images/edit-icon-outlined.svg"
                                        //                     alt="Edit Icon"
                                        //                     sx={{ width: 'unset' }}
                                        //                     onClick={openEditRiskProfile}
                                        //                 />
                                        //             </IconButton>
                                        //         )}
                                        //     </Box>
                                        //     <Box sx={{ mt: { xl: '40px', xs: '20px' } }}>
                                        //         {investorInfo?.riskScore > 0 ? (
                                        //             <>
                                        //                 <CustomGaugeChart data={Number(investorInfo?.riskScore)} />
                                        //                 <Box sx={{ textAlign: 'center', mt: '35px' }}>
                                        //                     <Typography variant="body_500" color={'text.secondary'} sx={{ mb: '10px' }}>
                                        //                         Risk tolerance is
                                        //                     </Typography>
                                        //                     <Typography variant="h1" sx={(theme: Theme) => ({
                                        //                         color: theme.palette.primary[500]
                                        //                     })}>
                                        //                         {findRiskTolerance(investorInfo?.profile)}
                                        //                     </Typography>
                                        //                     <Typography
                                        //                         variant="body_400"
                                        //                         sx={(theme: Theme) => ({
                                        //                             color: theme.palette.text.secondary,
                                        //                             mt: 2
                                        //                         })}
                                        //                     >
                                        //                         <Typography
                                        //                             component="span"
                                        //                             sx={{ fontWeight: "600" }}
                                        //                         >
                                        //                             {`Expiry Date: `}
                                        //                         </Typography>
                                        //                         {investorInfo?.riskProfileExpiryDate ? dayjs(investorInfo?.riskProfileExpiryDate).format('DD/MM/YYYY') : ""}
                                        //                     </Typography>
                                        //                 </Box>
                                        //             </>
                                        //         ) : (
                                        //             <Box
                                        //                 component="img"
                                        //                 src="/images/riskProfile.svg"
                                        //                 alt="Risk Profile"
                                        //                 width={'100%'}
                                        //                 height={'100%'}
                                        //                 sx={{ objectFit: "contain" }}
                                        //             />
                                        //         )}
                                        //     </Box>
                                        // </>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                height: "100%",
                                                minHeight: { xs: "500px", lg: "0px" },
                                                rowGap: "15px"
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Typography
                                                    variant="h2"
                                                    color="text.primary"
                                                    sx={{
                                                        letterSpacing: '0.01px',
                                                        lineHeight: '25px'
                                                    }}
                                                >
                                                    Risk Score
                                                </Typography>
                                                {/* {(isRMLikeRole(role)) && ( */}
                                                <IconButton
                                                    aria-label="Edit Risk Profile"
                                                    disabled={isFamilyView}
                                                    onClick={openEditRiskProfile}
                                                    sx={{
                                                        width: "40px",
                                                        height: "40px",
                                                        "&.Mui-disabled": {
                                                            backgroundColor: `${palette.text.secondary}40`,
                                                        }
                                                    }}
                                                >
                                                    <CardMedia
                                                        component="img"
                                                        src="/images/edit-icon-outlined.svg"
                                                        alt="Edit Icon"
                                                        sx={{ width: 'unset' }}
                                                    />
                                                </IconButton>
                                                {/* )} */}
                                            </Box>
                                            {investorInfo?.riskScore >= 0 ? (
                                                <>
                                                    <Box
                                                        sx={{
                                                            flexGrow: 1,
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <CustomGaugeChart data={Number(investorInfo?.riskScore)} />
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            marginTop: "10px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            rowGap: "10px",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body_500"
                                                            color='text.secondary'
                                                        >
                                                            Risk tolerance is
                                                        </Typography>
                                                        <Typography
                                                            variant="h1"
                                                            sx={(theme: Theme) => ({
                                                                // color: riskToleranceMapper[(investorInfo?.profile ?? "default").toLowerCase() as keyof typeof riskToleranceMapper]
                                                                color: getBgColorFromRisk(investorInfo?.riskScore)
                                                            })}
                                                        >
                                                            {investorInfo?.profile}
                                                        </Typography>
                                                        <Typography
                                                            variant="body_400"
                                                            sx={(theme: Theme) => ({
                                                                color: theme.palette.text.secondary,
                                                            })}
                                                        >
                                                            <Typography
                                                                component="span"
                                                                sx={{ fontWeight: "600" }}
                                                            >
                                                                {`Expiry Date: `}
                                                            </Typography>
                                                            {investorInfo?.riskProfileExpiryDate ? dayjs(investorInfo?.riskProfileExpiryDate).format('DD/MM/YYYY') : ""}
                                                        </Typography>
                                                    </Box>
                                                </>)
                                                : (
                                                    <Box
                                                        component="img"
                                                        src="/images/riskProfile.svg"
                                                        alt="Risk Profile"
                                                        width={'100%'}
                                                        height={'100%'}
                                                        sx={{ objectFit: "contain" }}
                                                    />
                                                )}
                                        </Box>
                                    )}
                                </Box>
                            </Grid >
                        )
                    }
                </Grid >

                {
                    (!investorInfoLoading && zeroStateCheck) ?
                        <Box
                            sx={(theme: Theme) => ({
                                backgroundColor: theme.palette.common.white,
                                borderRadius: "25px",
                                padding: "25px 30px",
                                height: "50vh",
                                mt: '25px'
                            })}
                        >
                            <ZeroStateInvestment isSuccess={zeroStateCheck} />
                        </Box>
                        :
                        <>
                            {/* Portfolio Health and Notifications */}
                            <Grid container sx={{ mt: '25px' }} rowGap={2} columnSpacing={3} height={'100%'}>

                                {/* Portfolio Health Chart*/}
                                {investedValueCheck ?
                                    <Grid item sm={12} lg={6.5} sx={{ width: '100%' }}>
                                        <Box
                                            sx={(theme: Theme) => ({
                                                backgroundColor: theme.palette.common.white,
                                                borderRadius: "25px",
                                                padding: "25px 30px",
                                                height: '100%'
                                            })}
                                        >
                                            <ZeroStateInvestment isSuccess={investedValueCheck} />
                                        </Box>
                                    </Grid>
                                    :
                                    <Grid item sm={12} lg={6.5} sx={{ width: '100%' }}>
                                        <PortfolioHealthChart
                                            isLoading={investorInfoLoading || benchmarkPerformanceLoader}
                                            getAllData={performanceData?.result}
                                            dynamicY={true}
                                            success={performanceData?.isSuccess}
                                            maskedData={maskedData}
                                        />

                                    </Grid>
                                }
                                {/* Notifications */}
                                <Grid item md={12} lg={5.5} sx={{ mt: { xs: '25px', md: 0 }, width: '100%' }}>
                                    <Box sx={(theme: Theme) => ({
                                        borderRadius: '25px',
                                        padding: '25px 30px',
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                        background: theme.palette.common.white,
                                        height: '100%'
                                    })}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '35px' }}>
                                            <Typography variant="h2" color="text.primary" sx={{ letterSpacing: '0.01px', lineHeight: '25px' }}>Notifications</Typography>
                                            <Button
                                                sx={(theme: Theme) => ({
                                                    ...theme.typography.body_500,
                                                    color: theme.palette.primary[500],
                                                    padding: "5px"
                                                })}
                                                disabled={
                                                    notificationsLoader ||
                                                    investorInfoLoading ||
                                                    !((notifications ?? []).length)
                                                }
                                                onClick={handleViewAllNotificationsClick}
                                            >
                                                View All
                                            </Button>
                                        </Box>
                                        {(notificationsLoader || investorInfoLoading) &&
                                            <Box>
                                                {[...Array(5)].map((_, index) => (
                                                    <React.Fragment key={index}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', columnGap: '15px', width: '100%', mb: '50px' }}>
                                                            <Box sx={{ display: 'flex', columnGap: '15px', flexDirection: 'row', width: '100%' }}>
                                                                <Box>
                                                                    <Skeleton animation="wave" variant="rectangular" width={25} height={25} />
                                                                </Box>
                                                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                                                                        {/* <Box>
                                                                            <Skeleton animation="wave" width={200} />
                                                                        </Box>
                                                                        <Box>
                                                                            <Box sx={{ display: 'flex', columnGap: '5px' }}>
                                                                                <Skeleton animation="wave" width={150} />
                                                                            </Box>
                                                                        </Box> */}
                                                                        <Skeleton animation="wave" width={150} />
                                                                        <Skeleton animation="wave" width={200} sx={{ display: { xs: 'none', md: 'block' } }} />
                                                                    </Box>
                                                                    <Box>
                                                                        <Skeleton animation="wave" width={200} />
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </React.Fragment>
                                                ))}

                                            </Box>
                                        }
                                        {(!notificationsLoader && !investorInfoLoading) && notifications?.length === 0 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Typography variant="body_600" color={'text.primary'} sx={{ textAlign: 'center', fontWeight: 500 }}>{NO_DATA_AVAILABLE}</Typography>
                                            </Box>
                                        )}
                                        {(!notificationsLoader && !investorInfoLoading) && notifications?.length > 0 &&
                                            <Box >
                                                {notifications?.map((notification, index) => {
                                                    const timestamp = !Number.isNaN(Number(notification.timestamp)) ? Number(notification.timestamp) : 0
                                                    const dayjsObj = dayjs(timestamp)
                                                    const notificationDate = dayjsObj.format('DD MMM, YY')
                                                    const notificationTime = dayjsObj.format('hh:mm A')
                                                    const isUrlValid = notification?.url?.startsWith('https')
                                                    return (
                                                        <Box key={index} sx={(theme: Theme) => ({ padding: index === 0 ? '0 0 20px 0' : '20px 0', display: 'flex', justifyContent: 'space-between', borderBottom: index !== 4 ? `0.5px solid ${theme.palette.text.secondary}B2` : 0, })}>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', columnGap: '15px', width: '100%' }}>
                                                                <Box sx={{ display: 'flex', columnGap: '15px', flexDirection: 'row', width: '100%', }}>
                                                                    <Box >
                                                                        {isLoading ? <Skeleton animation="wave" variant="rectangular" width={25} height={25} sx={{ borderRadius: '50%' }} /> : ["01", "04"].includes(notification?.type) ? <SuccessTickIcon /> : notification?.type === '02' ? <InProgressIcon width="20" height="30" /> : notification.type === '03' ? <FailureIcon width="20" height="30" /> : <SuccessTickIcon />}
                                                                    </Box>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', }}>
                                                                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', }}>
                                                                            <Box>
                                                                                {isLoading
                                                                                    ? <Skeleton animation="wave" width={200} />
                                                                                    :
                                                                                    <Typography variant="subtitle_500" color={'text.primary'} sx={{ letterSpacing: '0.02px', mb: '3px', flexWrap: 'wrap', fontWeight: '600' }}>
                                                                                        {notification?.title}
                                                                                    </Typography>
                                                                                }
                                                                            </Box>
                                                                            <Box>
                                                                                <Box sx={{ display: 'flex', columnGap: '5px' }}>
                                                                                    {isLoading ? <Skeleton animation="wave" width={150} /> : <>
                                                                                        <Typography variant="subtitle_500" color={'text.secondary'}>{notificationDate}</Typography>
                                                                                        <Typography variant="subtitle_500" color={'text.secondary'}>{notificationTime}</Typography>
                                                                                    </>}
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                        <Box >
                                                                            {isLoading ? <Skeleton animation="wave" width={200} /> : (
                                                                                <Box>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="overline_600"
                                                                                        color={'text.secondary'}
                                                                                    // sx={{
                                                                                    //     whiteSpace: "pre-line",
                                                                                    //     display: "-webkit-box",
                                                                                    //     overflow: "hidden",
                                                                                    //     WebkitBoxOrient: "vertical",
                                                                                    //     WebkitLineClamp: 2,

                                                                                    // }}
                                                                                    >
                                                                                        {notification?.subtitle}
                                                                                    </Typography>
                                                                                    {" "}
                                                                                    {(notification?.type === '04') ? (
                                                                                        <Typography
                                                                                            component="span"
                                                                                            variant="subtitle_500"
                                                                                            sx={(theme: Theme) => ({
                                                                                                color: theme.palette.primary[500],
                                                                                                textDecoration: 'underline',
                                                                                                cursor: 'pointer'
                                                                                            })}
                                                                                            onClick={handleMfcNotificationClick}
                                                                                        >
                                                                                            Please view
                                                                                        </Typography>
                                                                                    ) : null}
                                                                                    {"  "}
                                                                                    {(notification?.url) ? (
                                                                                        <Button
                                                                                            variant="text"
                                                                                            disabled={!isUrlValid}
                                                                                            sx={(theme: Theme) => ({
                                                                                                color: theme.palette.primary[500],
                                                                                                textDecoration: 'underline',
                                                                                                cursor: 'pointer',
                                                                                                padding: 0,
                                                                                                minWidth: 'auto',
                                                                                                '&.Mui-disabled': {
                                                                                                    color: theme.palette.text.secondary,
                                                                                                    textDecoration: 'none'
                                                                                                }
                                                                                            })}
                                                                                            onClick={() => handleMandateAuthenticationClick(index)}
                                                                                        >
                                                                                            Link
                                                                                        </Button>
                                                                                    ) : null}
                                                                                </Box>
                                                                            )}
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}
                                            </Box>
                                        }
                                    </Box>
                                </Grid>
                            </Grid>

                            {/* Asset Allocation and Portfolio Exposure Chart */}

                            {!investedValueCheck &&
                                <Grid container sx={{ mt: '25px' }} columnSpacing={3}>
                                    {/* Asset Allocation Chart */}
                                    <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                                        <Box sx={(theme: Theme) => ({
                                            borderRadius: '20px',
                                            padding: '25px 30px 45px 30px',
                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                            background: theme.palette.common.white,
                                            height: '100%'
                                        })}
                                        >
                                            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} sx={{ alignItems: { xs: 'baseline' } }}>
                                                <Typography variant="h2" sx={{
                                                    marginBottom: '40px'
                                                }}>Asset Allocation</Typography>
                                                <CustomDropdown
                                                    selectedValue={assetDropdownOptions}
                                                    handleValueChange={handleAssetDropdownChange}
                                                    isLoading={assetLoading || investorInfoLoading}
                                                    dropdownOptions={[
                                                        {
                                                            "label": "By Product",
                                                            "value": '1'
                                                        },
                                                        {
                                                            "label": "By Asset Class",
                                                            "value": '2'
                                                        }
                                                    ]} />

                                            </Box>
                                            {!assetLoading && !investorInfoLoading && !assetAllocation?.isSuccess ?
                                                <Typography
                                                    variant="body_600"
                                                    sx={(theme: Theme) => ({
                                                        fontWeight: 500,
                                                        lineHeight: "22.5px",
                                                        letterSpacing: "0.01px",
                                                        color: theme.palette.text.primary,
                                                        textAlign: 'center'
                                                    })}
                                                >
                                                    {NO_DATA_AVAILABLE}
                                                </Typography>
                                                :

                                                !assetLoading && (isAssetAllocationError || assetAllocation?.result?.data?.length === 0) ?
                                                    <ErrorText />
                                                    : <CustomePieChart {...{ ...assetAllocation?.result, isLoading: assetLoading, showSlider: true, maskedData: maskedData }} />
                                            }
                                        </Box>
                                    </Grid>

                                    {/* Portfolio Exposure Chart */}
                                    <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                                        <Box sx={(theme: Theme) => ({
                                            borderRadius: '20px',
                                            padding: '25px 30px 45px 30px',
                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                                            background: theme.palette.common.white,
                                            height: '100%'
                                        })}>
                                            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} sx={{ alignItems: { xs: 'baseline' } }}>
                                                <Typography variant="h2" sx={{
                                                    marginBottom: '40px'
                                                }}>Portfolio Exposure</Typography>
                                                <CustomDropdown
                                                    selectedValue={portfolioDropdownOptions}
                                                    handleValueChange={handlePortfolioChange}
                                                    isLoading={portfolioLoading || investorInfoLoading}
                                                    dropdownOptions={[
                                                        {
                                                            "label": "Sector Allocation",
                                                            "value": '1'
                                                        },
                                                        {
                                                            "label": "Company Exposure",
                                                            "value": '2'
                                                        }
                                                    ]} />

                                            </Box>
                                            {!portfolioLoading && !investorInfoLoading && !portfolioAllocation?.isSuccess ?
                                                <Typography
                                                    variant="body_600"
                                                    sx={(theme: Theme) => ({
                                                        fontWeight: 500,
                                                        lineHeight: "22.5px",
                                                        letterSpacing: "0.01px",
                                                        color: theme.palette.text.primary,
                                                        textAlign: 'center'
                                                    })}
                                                >
                                                    {NO_DATA_AVAILABLE}
                                                </Typography>
                                                :

                                                !portfolioLoading && (isPortfolioAllocationError || portfolioAllocation?.result?.data?.length === 0) ?
                                                    <ErrorText />
                                                    : <CustomePieChart {...{ ...portfolioAllocation?.result, isLoading: portfolioLoading, showSlider: true, maskedData: maskedData }} />
                                            }
                                        </Box>
                                    </Grid>
                                </Grid>
                            }


                            {/* Recent Recommendations Table */}

                            <Box sx={(theme: Theme) => ({
                                borderRadius: '25px',
                                padding: { xs: '25px 15px', sm: '25px 30px' },
                                background: theme.palette.common.white,
                                marginTop: '25px'
                            })}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '35px' }}>
                                    <Typography variant="h2" color={'text.primary'} sx={{ xs: { fontSize: "13px" } }}>Recent Recommendations</Typography>
                                    <Typography
                                        variant="body_500"
                                        component="span"
                                        role="button"
                                        tabIndex={isFamilyView ? -1 : 0}
                                        aria-label="View all recommendations"
                                        aria-disabled={isFamilyView}
                                        sx={(theme: Theme) => ({
                                            color: isFamilyView ? theme.palette.text.disabled : theme.palette.primary[500],
                                            cursor: isFamilyView ? 'default' : 'pointer',
                                            xs: { fontSize: "13px" },
                                            '&:focus-visible': {
                                                outline: `2px solid ${theme.palette.primary.main}`,
                                                outlineOffset: '2px',
                                                borderRadius: '4px',
                                            },
                                        })}
                                        onClick={() => !isFamilyView && (isRMLikeRole(role) ? history.push(`${pathName}/mutual-fund?tab=Recommendations`, { clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId }) : history.push('/investor-recommendations'))}
                                        onKeyDown={(e: React.KeyboardEvent) => {
                                            if ((e.key === 'Enter' || e.key === ' ') && !isFamilyView) {
                                                e.preventDefault();
                                                isRMLikeRole(role)
                                                    ? history.push(`${pathName}/mutual-fund?tab=Recommendations`, { clientCode: isRMLikeRole(role) ? navState?.clientCode : investorClientId })
                                                    : history.push('/investor-recommendations');
                                            }
                                        }}
                                    >
                                        View All
                                    </Typography>
                                </Box>

                                <Box>

                                    <CustomTable
                                        tableBody={
                                            <RecentRecommendationsTableBody
                                                tableBodyData={recentRecommendationsData}
                                                tableBodyRowCustomStyles={{
                                                    '& td:first-of-type': {
                                                        paddingLeft: "0px"
                                                    },
                                                }}
                                            />
                                        }
                                        tableData={recentRecommendationsData}
                                        tableBodyLoaderRowCustomStyles={{
                                            '& td:first-of-type': {
                                                paddingLeft: "0px"
                                            },
                                        }}
                                        tableHeaderData={tableHeaderData}
                                        handleSort={handleTableSorting}
                                        isPaginationVisible={false}
                                        tableHeadRowCustomStyles={{
                                            '& th:first-of-type': {
                                                paddingLeft: "0px"
                                            }
                                        }}

                                        tableBodyCustomStyles={{
                                            '& tr:last-child td': {
                                                border: 0
                                            }
                                        }}
                                        isShowMoreVisible={false}
                                        loadingRowsNum={6}
                                        tableDataCount={recentRecommendationsData?.length}
                                        isLoading={recommendationsLoading || investorInfoLoading}
                                        order={sortingObj.order}
                                        orderBy={sortingObj.orderBy}
                                        manualResponsiveBody={true}
                                        hideResponsiveHeader={true}
                                        ManualResponsiveBodyComponent={
                                            <MobileResponsiveRecentRecommendations
                                                tableBodyData={recentRecommendationsData}
                                                tableHeaderData={tableHeaderData}

                                            />
                                        }
                                        noResultMsg={NO_RECOMMENDATIONS}
                                    />


                                </Box>
                                <BottomMenu open={tableHeaderMenu} close={() => setTableHeaderMenu(false)} list={tableHeaderData} setTableHeaderKey={setTableHeaderKey} />

                            </Box>


                            {openRiskScore && <RiskScoreModal open={openRiskScore} close={closeEditRiskProfile} />}

                        </>
                }
            </Box >
            <Dialog
                onClose={closeExpiringMandateDialog}
                open={expiringMandateDialog}
                maxWidth="md"
                fullWidth
                // disableScrollLock
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '15px',
                        backgroundColor: "background.paper",
                    },
                }}
            >
                <Box>
                    <DialogContent>
                        <Box sx={{ display: "flex", columnGap: "8px", flexDirection: "column" }}>
                            <Typography variant="h3" color="text.primary" mb={3} sx={{ alignSelf: { xs: 'center', sm: 'flex-start' }, mb: { xs: 0, sm: 3 } }}>
                                {'Pending Mandate Authentication'}
                            </Typography>

                            <Grid container spacing={{ xs: 1, sm: 2 }}>
                                <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: { xs: 'row', sm: 'column' }, justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography variant="body_600">Mandate ID</Typography>
                                    <Typography variant="body_500">{pendingMandateData?.mandate?.mandateId ?? "-"}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: { xs: 'row', sm: 'column' }, justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography variant="body_600">Bank Name</Typography>
                                    <Typography variant="body_500">{pendingMandateData?.mandate?.bankName ?? "-"}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: { xs: 'row', sm: 'column' }, justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography variant="body_600">Amount</Typography>
                                    <Typography variant="body_500">{formatCurrency({
                                        value: pendingMandateData?.mandate?.amount ?? 0,
                                        locale,
                                        currencyCode

                                    })}</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ padding: "5px 25px 10px 25px", columnGap: "10px" }}>
                        <Button
                            variant="outlined"
                            onClick={closeExpiringMandateDialog}
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.secondary,
                                flex: 1,
                                border: `0.5px solid ${theme.palette.text.secondary}`,
                                padding: "6px",
                                borderRadius: '6px',
                                "&:hover, &.Mui-focusVisible": {
                                    borderColor: theme.palette.text.secondary,
                                    backgroundColor: theme.palette.background.default
                                }
                            })}
                        >
                            <Typography variant="body_500">Cancel</Typography>
                        </Button>
                        <Button
                            variant="contained"
                            sx={(theme: Theme) => ({
                                flex: 1,
                                color: theme.palette.textDark.primary,
                                padding: "6px",
                                borderRadius: '6px',
                            })}
                            onClick={handleAuthenticateClick}
                        >
                            <Typography variant="body_500">Authenticate</Typography>
                        </Button>
                    </DialogActions>
                    <Box sx={{ display: "flex", alignItems: "center", columnGap: "8px", padding: '10px 25px 10px 25px' }}>
                        <InfoIconOutlined
                            fontSize="small"
                        />
                        <Typography
                            variant="subtitle_500"
                            color="text.secondary"
                        >
                            {"If already authenticated,please wait for status updation."}
                        </Typography>
                    </Box>
                </Box>
            </Dialog>
        </>
    )
}